import React, { useContext, useEffect } from "react";
import BreakpointContext from "../../contexts/breakpointContext";
import DraftDispatchContext from "../../contexts/draftDispatchContext";
import DraftStateContext from "../../contexts/draftStateContext";
import useIsLoading from "../../hooks/queryResults/useIsLoading";
import useTeams from "../../hooks/queryResults/useTeams";
import useUserTeam from "../../hooks/queryResults/useUserTeam";
import TeamLogoAndName from "../team/TeamLogoAndName";
import Dropdown from "../ui/Dropdown";
import Loading from "../ui/Loading";
import { DRAFT_ACTIONS } from "./draftReducer";
import Roster from "./Roster";
import styled from "styled-components";
import TeamPicks from "./TeamPicks";

const StyledDropdownDiv = styled.div`
  display: flex,
  justify-content: center,
  border: 1px solid #aaa,
  border-radius: 0.5rem,
  
  & > div {
    margin: 0;
  }
`;

export default function Rosters() {
  const breakpoints = useContext(BreakpointContext);
  const draftState = useContext(DraftStateContext);
  const draftDispatch = useContext(DraftDispatchContext);
  const userTeam = useUserTeam();
  const { teams, teamsQuery } = useTeams();

  const { selectedTeamId } = draftState;

  const isLoading = useIsLoading(teams, teamsQuery, userTeam);

  const userTeamHasLoaded = !!userTeam && userTeam.hasLoaded();
  let userTeamId = userTeamHasLoaded ? userTeam.obj.id : null;

  useEffect(() => {
    if (!!userTeamId && !selectedTeamId) {
      draftDispatch({
        type: DRAFT_ACTIONS.SELECT_TEAM_ID,
        payload: userTeamId,
      });
    }
  }, [userTeamId, selectedTeamId, draftDispatch]);

  if (isLoading) return <Loading />;

  const items = [];
  teams.asArray().forEach((team) => {
    items.push({
      id: team.obj.id,
      value: <TeamLogoAndName team={team} week={1} />,
    });
  });

  const selectedTeam = selectedTeamId
    ? teams.getTeamById(selectedTeamId)
    : null;

  const ready = !!selectedTeam && items.length > 0;

  return !ready ? (
    <Loading />
  ) : (
    <div>
      <StyledDropdownDiv
        style={{
          display: "flex",
          justifyContent: "center",
          border: "1px solid #aaa",
          borderRadius: "0.5rem",
          width: breakpoints.sm ? "45%" : "100%",
        }}
      >
        <Dropdown
          selectedId={selectedTeamId}
          handleSelectItem={(item) => {
            draftDispatch({
              type: DRAFT_ACTIONS.SELECT_TEAM_ID,
              payload: item.id,
            });
          }}
          items={items}
          arrowColor={"black"}
        />
      </StyledDropdownDiv>
      <div
        style={{
          display: "flex",
          flexFlow: breakpoints.sm ? "row wrap" : "column nowrap",
          justifyContent: "space-around",
        }}
      >
        <div style={{ marginRight: "2%" }}>
          <TeamPicks team={selectedTeam} />
        </div>
        <div style={{ marginRight: "2%" }}>
          <Roster team={selectedTeam} />
        </div>
      </div>
    </div>
  );
}
